module.exports = __webpack_public_path__ + "img/right.19782c6e.png";